import form from '@wwdev/forms';

class Login {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-login-modal="scope"]',
			button: '[data-login-modal="button"]',
			modal: '[data-login-modal="modal"]',
			content: '[data-login-modal="content"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('click', this.config.button, this.openModal.bind(this));
		$(document).on('submit', `${this.config.modal} form`, this.login.bind(this));
	}

	openModal(event) {
		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);
		let $modal = $($button.data('modal'));
		let modal = bootstrap.Modal.getOrCreateInstance($modal[0]);
		modal.show();

		if ($button.data('loaded') == 'true') {
			return;
		}

		$.ajax({
			url: $button.data('src'),
			data: {
				destination: window.location.href
			},
			success: this.onSuccess.bind(this, $modal),
			error: this.onError.bind(this, $modal),
		}).always(() => {
			$button.data('loaded', 'true');
		});
	}

	onSuccess($modal, response) {
		let $content = $modal.find(this.config.content);
		$content.html(response);
		form.init($content.find('form')[0]);
	}

	onError($modal, error) { }

	login(event) {
		event.preventDefault();

		let $form = $(event.currentTarget);
		let $modal = $form.closest(this.config.modal);

		$.ajax({
			url: $form.attr('action'),
			method: 'post',
			data: $form.serializeObject(),
			success: this.onLoginSuccess.bind(this, $modal),
			error: this.onLoginError.bind(this, $modal),
		});
	}

	onLoginSuccess($modal, response) {
		location.reload();
	}

	onLoginError($modal, response) {
		let errors = response.responseJSON.errors;

		for(let name in errors) {
			let $input = $modal.find(`:input[name="${name}"]`);
			let $error = $modal.find(`#${name}-error`);

			if($error.length < 1) {
				$error = $('<label></label>');
				$error.attr('for', name);
				$error.attr('id', `${name}-error`);
			}

			$input.removeClass('valid');
			$input.addClass('error');
			$error.addClass('error');
			$error.html(errors[name][0]);
			$error.css('display', '');
			$input.after($error);
		}
	}
}

export default Login;